/** @format */

import React from 'react'

const ContactUs = () => {
	return <div>contact us Page</div>
}

export default ContactUs
